export default {"src":"/_next/static/media/main-products-icon.983bc5e0.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};